import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();
  const path = location.pathname.split('/')[1] || 'home';

  const menuItems = {
    home: [
      { title: 'Getting Started', path: '/' },
      { title: 'Tutorials', path: '/tutorials' },
      { title: 'References', path: '/references' },
      { title: 'Exercises', path: '/exercises' },
    ],
    html: [
      { title: 'HTML Introduction', path: '/html/intro' },
      { title: 'HTML Basic', path: '/html/basic' },
      { title: 'HTML Elements', path: '/html/elements' },
      { title: 'HTML Attributes', path: '/html/attributes' },
      { title: 'HTML Headings', path: '/html/headings' },
    ],
    css: [
      { title: 'CSS Introduction', path: '/css/intro' },
      { title: 'CSS Syntax', path: '/css/syntax' },
      { title: 'CSS Selectors', path: '/css/selectors' },
      { title: 'CSS Box Model', path: '/css/box-model' },
    ],
    javascript: [
      { title: 'JS Introduction', path: '/javascript/intro' },
      { title: 'JS Where To', path: '/javascript/where-to' },
      { title: 'JS Output', path: '/javascript/output' },
      { title: 'JS Statements', path: '/javascript/statements' },
    ],
    python: [
      { title: 'Python Introduction', path: '/python/intro' },
      { title: 'Python Syntax', path: '/python/syntax' },
      { title: 'Python Variables', path: '/python/variables' },
      { title: 'Python Data Types', path: '/python/data-types' },
    ],
    mysql: [
      { title: 'MySQL Introduction', path: '/mysql/intro' },
      { title: 'MySQL RDBMS', path: '/mysql/rdbms' },
      { title: 'MySQL SQL', path: '/mysql/sql' },
      { title: 'MySQL Database', path: '/mysql/database' },
    ],
    git: [
      { title: 'Git Introduction', path: '/git/intro' },
      { title: 'Git Get Started', path: '/git/get-started' },
      { title: 'Git Branch', path: '/git/branch' },
      { title: 'Git Push', path: '/git/push' },
    ],
  };

  const items = menuItems[path] || menuItems.home;

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3>{path === 'home' ? 'Tutorials' : path.toUpperCase()}</h3>
      </div>
      <ul className="sidebar-menu">
        {items.map((item, index) => (
          <li key={index}>
            <Link to={item.path} className={location.pathname === item.path ? 'active' : ''}>
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
